import React from "react";

import { Shimmer, ShimmerKeyframes } from "./Shimmer";

const d = (n: number) => `${n}s`;

const WEEKS = 6;
const DAYS_PER_WEEK = 7;

const eventLayout: Record<number, number[]> = {
  0: [80, 60],
  3: [90],
  6: [70, 50, 40],
  10: [85],
  14: [60],
  18: [75, 55],
  22: [80],
  27: [50],
  32: [70, 90],
  37: [60],
};

const WorkOrderCalendarSkeleton = () => (
  <>
    <ShimmerKeyframes />
    <div className="flex flex-col gap-md w-full">
      <div className="flex items-center justify-between gap-md px-md">
        <div className="flex items-center gap-sm">
          <Shimmer className="w-3xl h-3xl rounded" delay={d(0)} />
          <Shimmer className="w-3xl h-3xl rounded" delay={d(0.05)} />
          <Shimmer className="h-lg w-[160px] rounded" delay={d(0.1)} />
        </div>
        <Shimmer className="h-3xl w-[100px] rounded" delay={d(0.15)} />
      </div>

      <div
        className="grid border border-solid border-primary rounded-lg overflow-hidden bg-primary"
        style={{
          gridTemplateColumns: `repeat(${DAYS_PER_WEEK}, minmax(0, 1fr))`,
        }}
      >
        {Array.from({ length: DAYS_PER_WEEK }).map((_, i) => (
          <div
            key={`head-${i}`}
            className="px-md py-sm bg-tertiary border-solid border-0 border-b border-primary"
          >
            <Shimmer
              className="h-sm w-[40px] rounded"
              delay={d(0.2 + i * 0.02)}
            />
          </div>
        ))}

        {Array.from({ length: WEEKS * DAYS_PER_WEEK }).map((_, cellIdx) => {
          const events = eventLayout[cellIdx] || [];
          const colIdx = cellIdx % DAYS_PER_WEEK;
          const rowIdx = Math.floor(cellIdx / DAYS_PER_WEEK);
          const isLastCol = colIdx === DAYS_PER_WEEK - 1;
          const isLastRow = rowIdx === WEEKS - 1;
          return (
            <div
              key={cellIdx}
              className={`flex flex-col gap-xs p-sm h-[100px] border-solid border-0 border-primary ${
                !isLastCol ? "border-r" : ""
              } ${!isLastRow ? "border-b" : ""}`}
            >
              <Shimmer
                className="h-sm w-[20px] rounded"
                delay={d(0.3 + cellIdx * 0.005)}
              />
              {events.map((width, eventIdx) => (
                <Shimmer
                  key={eventIdx}
                  className="h-md rounded"
                  style={{ width: `${width}%` }}
                  delay={d(0.4 + cellIdx * 0.005 + eventIdx * 0.05)}
                />
              ))}
            </div>
          );
        })}
      </div>
    </div>
  </>
);

export default WorkOrderCalendarSkeleton;
